import { Box, styled } from "@mui/material";

export const StyledBlogFooter = styled(Box)(({ theme }) => ({
  width: "100%",
}));

